import React, { Component, Fragment } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import { IconButton, Tooltip } from "@material-ui/core";
import { Visibility as ViewIcon, Edit as EditIcon } from "@material-ui/icons";
import {
  withModulesManager,
  withHistory,
  formatMessage,
  formatMessageWithValues,
  formatDateFromISO,
  Searcher,
} from "@openimis/fe-core";
import { fetchFamilyEnrollments } from "../actions";
import EnrollmentFilter from "./EnrollmentFilter";
import EnrollmentStatusBadge from "./common/EnrollmentStatusBadge";
import {
  DEFAULT_ENROLLMENT_FILTERS,
  DEFAULT_PAGE_SIZE,
  ROWS_PER_PAGE_OPTIONS,
} from "../constants";
import { filtersToQueryParams, enrollmentRowIdentifier } from "../utils/searcher";
import {
  normalizeFamilyData,
  formatDisplayValue,
} from "../utils/enrollmentData";

class FamilyEnrollmentSearcher extends Component {
  constructor(props) {
    super(props);
    this.rowsPerPageOptions = props.modulesManager.getConf(
      "fe-enrollment",
      "familyEnrollmentFilter.rowsPerPageOptions",
      ROWS_PER_PAGE_OPTIONS
    );
    this.defaultPageSize = props.modulesManager.getConf(
      "fe-enrollment",
      "familyEnrollmentFilter.defaultPageSize",
      DEFAULT_PAGE_SIZE
    );
  }

  fetch = (prms) => {
    this.props.fetchFamilyEnrollments(this.props.modulesManager, prms);
  };

  openEdit = (e) => {
    if (this.props.history) {
      this.props.history.push(`/enrollment/family/${e.uuid}/edit`);
    }
  };

  headers = () => [
    "familyEnrollment.headOfFamily",
    "familyEnrollment.location",
    "familyEnrollment.address",
    "familyEnrollment.phone",
    "familyEnrollment.status",
    "familyEnrollment.enrollmentDate",
    "",
  ];

  sorts = () => [null, null, null, null, ["status", true], ["dateCreated", false], null];

  itemFormatters = () => {
    const { modulesManager, intl, onDoubleClick } = this.props;
    return [
      (e) => {
        const f = normalizeFamilyData(e.data);
        return (
          [f.headOtherNames, f.headLastName].filter(Boolean).join(" ") || "—"
        );
      },
      (e) => formatDisplayValue(normalizeFamilyData(e.data).locationId),
      (e) => formatDisplayValue(normalizeFamilyData(e.data).address),
      (e) => formatDisplayValue(normalizeFamilyData(e.data).headPhone),
      (e) => <EnrollmentStatusBadge status={e.status || "DRAFT"} size="small" />,
      (e) => formatDateFromISO(modulesManager, intl, e.dateCreated) || "-",
      (e) => (
        <>
          <Tooltip title={formatMessage(intl, "enrollment", "general.view") || "View"}>
            <IconButton
              size="small"
              onClick={(ev) => {
                ev.stopPropagation();
                onDoubleClick && onDoubleClick(e);
              }}
            >
              <ViewIcon fontSize="small" />
            </IconButton>
          </Tooltip>
          {e.status === "DRAFT" && (
            <Tooltip title={formatMessage(intl, "enrollment", "general.edit") || "Edit"}>
              <IconButton
                size="small"
                onClick={(ev) => {
                  ev.stopPropagation();
                  this.openEdit(e);
                }}
              >
                <EditIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          )}
        </>
      ),
    ];
  };

  render() {
    const {
      intl,
      familyEnrollments,
      familyEnrollmentsPageInfo,
      fetchingFamilyEnrollments,
      fetchedFamilyEnrollments,
      errorFamilyEnrollments,
      cacheFiltersKey,
      onDoubleClick,
    } = this.props;

    const totalCount =
      familyEnrollmentsPageInfo?.totalCount ?? familyEnrollments?.length ?? 0;

    return (
      <Fragment>
        <Searcher
          module="enrollment"
          cacheFiltersKey={cacheFiltersKey}
          FilterPane={EnrollmentFilter}
          items={familyEnrollments}
          itemsPageInfo={{ ...familyEnrollmentsPageInfo, totalCount }}
          fetchingItems={fetchingFamilyEnrollments}
          fetchedItems={fetchedFamilyEnrollments}
          errorItems={errorFamilyEnrollments}
          tableTitle={formatMessageWithValues(
            intl,
            "enrollment",
            "familyEnrollment.searcher.results",
            { count: totalCount.toLocaleString() }
          )}
          rowsPerPageOptions={this.rowsPerPageOptions}
          defaultPageSize={this.defaultPageSize}
          defaultFilters={DEFAULT_ENROLLMENT_FILTERS}
          defaultOrderBy="-dateCreated"
          fetch={this.fetch}
          rowIdentifier={enrollmentRowIdentifier}
          filtersToQueryParams={filtersToQueryParams}
          headers={this.headers}
          itemFormatters={this.itemFormatters}
          sorts={this.sorts}
          onDoubleClick={(i) => onDoubleClick && onDoubleClick(i)}
        />
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  familyEnrollments: state.enrollment?.familyEnrollments || [],
  familyEnrollmentsPageInfo: state.enrollment?.familyEnrollmentsPageInfo || {},
  fetchingFamilyEnrollments: state.enrollment?.fetchingFamilyEnrollments,
  fetchedFamilyEnrollments: state.enrollment?.fetchedFamilyEnrollments,
  errorFamilyEnrollments: state.enrollment?.errorFamilyEnrollments,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ fetchFamilyEnrollments }, dispatch);

export default withModulesManager(
  withHistory(
    connect(mapStateToProps, mapDispatchToProps)(injectIntl(FamilyEnrollmentSearcher))
  )
);
